import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'
const urlRecursosVinculados = '/service/contabilidade/recursovinculado/'

class RecursosVinculadosService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getRecursosVinculados() {
        return this.conex.get(urlRecursosVinculados + 'todos/')
    }

    getRecursosVinculadosPorEx(exercicio) {
        return this.conex.get(urlRecursosVinculados + 'recursosPorExercicio/' + exercicio)
    }

    getRecursosVinculadosPorExercicio() {
        return this.conex.get(urlRecursosVinculados + 'listaExercicios/')
    }
}

export default RecursosVinculadosService